<template>
  <div :id="'comment-' + id" class="relative my-5">
    <div>
      <div class="relative shadow shadow-zt-shadow bg-zt-normal border -m-[1px] rounded-md"
           :class="showNewBetShadow ? 'border-zt-more' : 'border-zt-normal', {'z-backdrop': isBetOptionsModalOpen }">
        <Transition name="fade">
          <bet-options-modal v-if="isBetOptionsModalOpen"
                             :betId="id"
                             :authorId="authorId"
                             :authorName="authorName"
                             :isFollowed="isFollowed"
                             :isBlocked="isUserBlocked"
                             :isBetAd="true"
                             :isSuperkursAd="isSuperkursAd"
                             :betPostId="postId"
                             @close="hideBetOptionsModal"
                             @block="blockUser"
                             @unblock="unblockUser"
                             @follow="follow"
                             @unfollow="unfollow"
                             @edit="edit"
                             @deleteBet="deleteBet"
                             @settleBet="settleBet" />
        </Transition>
        <div class="flex relative items-center rounded-t-md border-b border-zt-light/35 py-3 pl-3 pr-4 xl:pr-[18px] xl:pt-2.5 xl:pb-3">
          <div class="flex items-center group cursor-pointer" rel="nofollow" @click="handleClick">
            <div v-if="bookmaker">
              <div class="relative">
                <img class="w-[50px] h-[50px] mr-2 group-hover:brightness-90 group-active:brightness-75"
                     :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/logo_${bookmakerLogoName.toLowerCase().replaceAll(' ', '')}_kod_promocyjny.svg`"
                     :alt="`Logo ${bookmakerLogoName} kod promocyjny`" width="50" height="50" />
                <div v-if="isFollowed"
                     class="absolute right-1 bottom-0 bg-zt-main rounded-full w-5 h-5 flex justify-center items-center"
                     :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                     data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                  <svg width="11" height="11" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 3.71875C8.5 5.18575 7.31075 6.375 5.84375 6.375C4.37675 6.375 3.1875 5.18575 3.1875 3.71875C3.1875 2.25175 4.37675 1.0625 5.84375 1.0625C7.31075 1.0625 8.5 2.25175 8.5 3.71875Z" fill="white" />
                    <path d="M3.1875 8.5C1.4271 8.5 0 9.9271 0 11.6875V14.875H8.5V8.5H3.1875Z" fill="white" />
                    <path d="M13.8125 8.5H10.625V14.875H17V11.6875C17 9.9271 15.573 8.5 13.8125 8.5Z" fill="white" />
                    <path d="M12.75 6.375C13.9236 6.375 14.875 5.42361 14.875 4.25C14.875 3.07639 13.9236 2.125 12.75 2.125C11.5764 2.125 10.625 3.07639 10.625 4.25C10.625 5.42361 11.5764 6.375 12.75 6.375Z" fill="white" />
                  </svg>
                </div>
                <div v-if="isBlocked"
                     class="opacity-40 absolute top-0 left-0 rounded-full bg-black w-[50px] h-[50px] flex items-center justify-center">
                  <svg class="w-[30px] h-[30px]" viewBox="0 0 214 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M197.131 122.59H16.2847C6.8567 122.59 0 130.305 0 138.878V302.617C0 312.048 7.71379 318.906 16.2847 318.906H197.131C206.559 318.906 213.415 311.19 213.415 302.617V138.878C213.415 130.305 205.701 122.59 197.131 122.59ZM128.563 270.898H85.7089C79.7093 270.898 75.4239 264.897 77.9951 258.896L91.7085 229.749C93.4227 226.32 92.5656 222.034 89.1373 219.462C83.1377 214.318 79.7093 207.46 79.7093 198.887C79.7093 178.313 101.994 162.882 124.278 176.598C126.849 178.313 128.563 180.027 129.42 182.599C137.991 197.173 134.563 211.746 125.135 220.319C122.564 222.891 120.85 227.177 122.564 230.606L136.277 259.754C137.991 264.04 134.563 270.898 128.563 270.898Z" fill="white" />
                    <path d="M107.138 0C64.2836 0 30 35.1483 30 77.1547V102.016H62.5694V77.1547C62.5694 52.2938 82.2825 32.5764 107.138 32.5764C131.994 32.5764 151.707 52.2938 151.707 77.1547V102.016H184.276V77.1547C185.133 34.291 149.993 0 107.138 0Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="relative">
                <img :src="authorAvatar" alt="" width="50" height="50"
                     class="!rounded-full w-[50px] h-[50px] mr-2 group-hover:brightness-90 group-active:brightness-75"
                     :class="isModal ? 'post-thumbnail' : ''" @error="handleUserAvatarError($event)"/>
                <div v-if="isFollowed"
                     class="absolute right-1 bottom-0 bg-zt-main rounded-full w-5 h-5 flex justify-center items-center"
                     :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                     data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                  <svg width="11" height="11" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 3.71875C8.5 5.18575 7.31075 6.375 5.84375 6.375C4.37675 6.375 3.1875 5.18575 3.1875 3.71875C3.1875 2.25175 4.37675 1.0625 5.84375 1.0625C7.31075 1.0625 8.5 2.25175 8.5 3.71875Z" fill="white" />
                    <path d="M3.1875 8.5C1.4271 8.5 0 9.9271 0 11.6875V14.875H8.5V8.5H3.1875Z" fill="white" />
                    <path d="M13.8125 8.5H10.625V14.875H17V11.6875C17 9.9271 15.573 8.5 13.8125 8.5Z" fill="white" />
                    <path d="M12.75 6.375C13.9236 6.375 14.875 5.42361 14.875 4.25C14.875 3.07639 13.9236 2.125 12.75 2.125C11.5764 2.125 10.625 3.07639 10.625 4.25C10.625 5.42361 11.5764 6.375 12.75 6.375Z" fill="white" />
                  </svg>
                </div>
                <div v-if="isBlocked"
                     class="opacity-40 absolute top-0 left-0 rounded-full bg-black w-[50px] h-[50px] flex items-center justify-center">
                  <svg class="w-[30px] h-[30px]" viewBox="0 0 214 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M197.131 122.59H16.2847C6.8567 122.59 0 130.305 0 138.878V302.617C0 312.048 7.71379 318.906 16.2847 318.906H197.131C206.559 318.906 213.415 311.19 213.415 302.617V138.878C213.415 130.305 205.701 122.59 197.131 122.59ZM128.563 270.898H85.7089C79.7093 270.898 75.4239 264.897 77.9951 258.896L91.7085 229.749C93.4227 226.32 92.5656 222.034 89.1373 219.462C83.1377 214.318 79.7093 207.46 79.7093 198.887C79.7093 178.313 101.994 162.882 124.278 176.598C126.849 178.313 128.563 180.027 129.42 182.599C137.991 197.173 134.563 211.746 125.135 220.319C122.564 222.891 120.85 227.177 122.564 230.606L136.277 259.754C137.991 264.04 134.563 270.898 128.563 270.898Z" fill="white" />
                    <path d="M107.138 0C64.2836 0 30 35.1483 30 77.1547V102.016H62.5694V77.1547C62.5694 52.2938 82.2825 32.5764 107.138 32.5764C131.994 32.5764 151.707 52.2938 151.707 77.1547V102.016H184.276V77.1547C185.133 34.291 149.993 0 107.138 0Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-center grow h-[50px] xl:h-fit">
              <div v-if="bookmaker" class="block max-w-fit text-ellipsis whitespace-nowrap overflow-hidden cursor-pointer p-2 -m-2">
                <span class="searched-in font-semibold group-hover:brightness-90 group-active:brightness-75 group-hover:underline xl:text-[16px] xl:leading-5"
                      v-html="bookmaker"></span>
              </div>
              <div v-else class="no-default-style block w-fit px-2.5 text-ellipsis whitespace-nowrap overflow-hidden">
                <span class="searched-in font-semibold text-base whitespace-normal group-hover:brightness-90 group-active:brightness-75 group-hover:underline"
                      v-html="authorName"></span>
              </div>
            </div>
          </div>
          <div @click="showBetOptionsModal('comment-' + id)"
               class="border border-zt-light rounded-[8px] shrink-0 ml-auto cursor-pointer highlight-none fill-[#D9D9D9]
                      transition-colors self-center flex justify-center items-center m-0 zt-hover hover:bg-zt-light
                      h-[42px] w-[42px]
                      xl:self-center xl:h-[49px] xl:min-w-[49px] xl:max-w-[49px]">
            <svg width="23" height="5" viewBox="0 0 23 5" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="20.5" cy="2.49031" rx="2.5" ry="2.49031" />
              <ellipse cx="11.5" cy="2.49031" rx="2.5" ry="2.49031" />
              <ellipse cx="2.5" cy="2.49031" rx="2.5" ry="2.49031" />
            </svg>
          </div>
        </div>
        <div v-if="bookmaker" class="add-bet flex flex-col px-2.5 py-2 xl:px-4">
          <div class="grid grid-cols-3 gap-2 pt-2.5 pb-2.5 px-2 xl:px-8">
            <div class="flex flex-col items-center relative gap-1.5 xl:gap-3">
              <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                <img v-if="discipline.toLowerCase() !== 'inna' || discipline !== 'Pozostałe'"
                     class="w-[22px] h-[22px] opacity-50" :class="isModal ? '!m-0' : ''"
                     :src="'/wp-content/themes/zawodtyper/assets/images/dyscypliny/' + disciplineLogoName.replace(' ', '').toLowerCase() + '.svg'"
                     :alt="discipline" />
                <img v-else
                     class="w-[22px] h-[22px] opacity-50"
                     :src="'/wp-content/themes/zawodtyper/assets/images/dyscypliny/inna.svg'"
                     :alt="discipline" :class="isModal ? '!m-0' : ''" width="20" height="20" />
              </div>
              <div class="text-center">
                <p class="text-[#ABC1E2] text-xs w-full font-semibold">DYSCYPLINA</p>
                <div v-if="!toEdit" :id="'discipline' + data.comment_id" :contenteditable="toEdit"
                     class="searched-in text-sm mt-0.5 whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold xl:mt-0"
                     v-html="discipline"></div>
                <select v-else :id="'discipline' + data.comment_id"
                        class="text-white w-full rounded-md bg-zt-normal border-white/50 border h-8 text-sm focus:outline-none"
                        v-model="discipline">
                  <option v-for="(discipline, index) in disciplines" :selected="index === 0">
                    {{ discipline.title }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex flex-col items-center relative gap-1.5 xl:gap-3">
              <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.9977 14.5269L14.5252 12.9994L9.1627 7.63689L7.63521 9.16439L12.9977 14.5269ZM20.6569 5.34022C19.6536 4.33081 18.4601 3.53049 17.1454 2.98563C15.8306 2.44077 14.4209 2.1622 12.9977 2.16606H11.9144V6.49939H14.081V4.39772C16.0239 4.64329 17.8264 5.53963 19.1946 6.94068C20.5629 8.34172 21.4164 10.1649 21.6159 12.113C21.8154 14.0612 21.3492 16.0195 20.2933 17.6688C19.2375 19.3181 17.6541 20.5612 15.8013 21.1955C13.9485 21.8298 11.9356 21.8179 10.0904 21.1617C8.24528 20.5055 6.67676 19.2438 5.64047 17.5821C4.60418 15.9204 4.16122 13.9567 4.38378 12.0111C4.60633 10.0654 5.48128 8.25248 6.86604 6.86772L7.63521 6.10939L6.10771 4.57106L5.33854 5.34022C4.30384 6.33956 3.47854 7.53496 2.91077 8.85667C2.34301 10.1784 2.04416 11.5999 2.03166 13.0384C2.01916 14.4768 2.29326 15.9033 2.83797 17.2347C3.38268 18.5661 4.18709 19.7757 5.20426 20.7928C6.22143 21.81 7.43099 22.6144 8.76237 23.1591C10.0937 23.7038 11.5203 23.9779 12.9587 23.9654C14.3972 23.9529 15.8187 23.6541 17.1404 23.0863C18.4621 22.5186 19.6575 21.6933 20.6569 20.6586C22.6878 18.627 23.8287 15.872 23.8287 12.9994C23.8287 10.1268 22.6878 7.37177 20.6569 5.34022Z" fill="#93A3BA" />
                </svg>
              </div>
              <div class="text-center">
                <p class="text-[#ABC1E2] text-xs w-full font-semibold">GODZINA</p>
                <div :id="'hour' + data.comment_id" :contenteditable="toEdit"
                     class="text-sm mt-0.5 whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold xl:mt-0">
                  {{ hour }}
                </div>
              </div>
            </div>
            <div class="flex flex-col items-center relative gap-1.5 xl:gap-3">
              <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                <img class="w-6 h-6 cursor-pointer zt-hover"
                     :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/logo_${bookmakerLogoName.toLowerCase().replaceAll(' ', '')}_kod_promocyjny.svg`"
                     width="24" height="24" :alt="`Logo ${bookmakerLogoName} kod promocyjny`"
                     @click="redirectToPromoPage(promoUrl, true); countClicks('Bukmacher w TD - analityka LOGO');" />
              </div>
              <div class="text-center">
                <p class="text-[#ABC1E2] text-xs w-full font-semibold">BUKMACHER</p>
                <div v-if="!toEdit" :id="'bookmaker' + data.comment_id"
                     class="searched-in text-sm whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold mt-0.5 xl:mt-0">
                  <div class="zt-hover cursor-pointer" rel="nofollow"
                       @click="changeUrl(getBookmakerLink(bookmaker, isFeaturedBet))"
                       v-html="bookmaker"></div>
                </div>
                <select v-else :id="'bookmaker' + data.comment_id" :contenteditable="toEdit" :content="bookmaker"
                        class="text-white w-full rounded-md bg-zt-normal border-white/50 border h-8 text-sm focus:outline-none"
                        v-model="bookmaker">
                  <option selected>Fortuna</option>
                  <option>LVBET</option>
                  <option>eWinner</option>
                  <option>Betfan</option>
                  <option>Betclic</option>
                  <option>Totolotek</option>
                  <option>forBET</option>
                  <option>PZBuk</option>
                  <option>BestBet</option>
                  <option>STS</option>
                  <option>Superbet</option>
                  <option>TOTALbet</option>
                  <option>Fuksiarz</option>
                  <option>ETOTO</option>
                  <option>Betters</option>
                  <option>Noblebet</option>
                  <option>ComeOn</option>
                  <option>Lebull</option>
                  <option>Betsport</option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="toEdit" class="pb-4 pt-2 flex flex-col items-center bg-zt-main my-2 rounded-lg px-4">
            <p class="text-[#ABC1E2] text-[12px] text-center w-full font-semibold">ZMIEŃ DATĘ</p>
            <input class="bg-white/20 px-2 rounded-zt" type="date" id="start" name="trip-start" v-model="editDate" />
          </div>
          <div class="p-2 h-[60px] flex flex-col justify-center items-center bg-zt-main my-2.5 rounded-lg relative xl:my-1.5">
            <p class="text-[#ABC1E2] text-xs text-center w-full font-semibold">WYDARZENIE</p>
            <div :id="'match-name' + data.comment_id" ref="matchName" :contenteditable="toEdit"
                 class="text-center max-w-full text-sm whitespace-nowrap overflow-x-scroll pt-1 font-semibold"
                 @scroll="scrollMatchHandler($event)">
              <div class="text-center relative">
                <div class="searched-in" v-html="matchName"></div>
              </div>
            </div>
            <svg v-if="matchScrollableLeft"
                 class="absolute top-1/2 left-[5px]"
                 @click="scrollElementToLeft('match-name' + data.comment_id)"
                 width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.15625 7.75125L2.91208 4.5L6.15625 1.24875L5.1575 0.25L0.9075 4.5L5.1575 8.75L6.15625 7.75125Z" fill="white" />
            </svg>
            <svg v-if="matchScrollableRight"
                 class="absolute top-1/2 right-[5px]"
                 @click="scrollElementToRight('match-name' + data.comment_id)"
                 width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.726563 7.75125L3.7799 4.5L0.726563 1.24875L1.66656 0.25L5.66656 4.5L1.66656 8.75L0.726563 7.75125Z" fill="white" />
            </svg>
            <div v-if="matchScrollableLeft"
                 class="absolute top-1/2 left-[15px] w-[10px] h-[14px] bg-gradient-to-r from-zt-light to-transparent"></div>
            <div v-if="matchScrollableRight"
                 class="absolute top-1/2 right-[15px] w-[10px] h-[14px] bg-gradient-to-l from-zt-light to-transparent"></div>
          </div>
          <div class="pb-4 pt-1.5 px-4 h-[60px] flex flex-col items-center bg-zt-main mt-2.5 mb-7 rounded-lg relative xl:mt-1.5">
            <div v-if="toEdit" class="flex text-xs items-center gap-x-[6px]">
              Superkurs
              <div
                  @click="editIsBetBuilder = !editIsBetBuilder"
                  class="flex items-center gap-2.5 font-light w-5 h-5 cursor-pointer zt-hover text-[#EEE]">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :fill="editIsBetBuilder ? '#FF4A5D' : '#3A4B6459'" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38985 15.9466L5.30791 12.2349L3.94727 13.4721L9.38985 18.4211L21.0525 7.81621L19.6919 6.57898L9.38985 15.9466Z"
                        :fill="editIsBetBuilder ? 'white' : 'transparent'" />
                  <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :stroke="editIsBetBuilder ? '#9B2733' : '#3A4B64'" />
                </svg>
              </div>
            </div>
            <p class="text-[#ABC1E2] text-xs text-center w-full font-semibold">TYP {{ isBetbuilder ? ' (SUPERKURS)' : '' }}</p>
            <div :id="'type' + data.comment_id" ref="type" :contenteditable="toEdit"
                 class="text-center max-w-full text-sm whitespace-nowrap overflow-x-scroll font-semibold"
                 @scroll="scrollTypeHandler($event)">
              <div class="searched-in text-center relative" v-html="type"></div>
            </div>
            <div class="absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 rounded-zt h-[26px]
                   flex justify-center items-center w-[90px] overflow-hidden border border-transparent cursor-default select-none"
                 :class="settled
                   ? [getSettleBgColor(), { 'after:absolute after:bg-white after:w-[10%] after:h-full after:top-0 after:right-[110%] after:animate-[bet-result-shine_24s_ease-in-out_infinite] after:blur after:skew-x-12 after:transition-transform': result === 1 }]
                   : 'rate-unchecked'"
                 @click="hideTooltip" data-bs-trigger="click"
                 data-bs-toggle="tooltip" data-bs-delay="500" data-bs-placement="bottom"
                 :title="settled ? (result === 1 ? 'Wygrana' : result === -1 ? 'Przegrana' : result === -2 ? 'Odrzucony (czarny kurs)' : 'Zwrot') : 'Nierozliczony'">
              <div :id="'rate' + data.comment_id" :contenteditable="toEdit"
                   class="text-center text-base whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold relative z-10">
                {{ rate }}
              </div>
              <div v-if="5 <= rate && rate < 10 && settled && result === 1">
                <svg class="absolute right-1 top-0 h-8 w-4" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3235 17.5098V19.2193H11.658V20.2944H13.3235V22.0039H14.4867V20.2944H16.1522V19.2193H14.4867V17.5098H13.3235Z" fill="#038733" />
                  <path d="M2.84954 11.3088V13.5882H0.628906V15.0216H2.84954V17.301H4.40047V15.0216H6.6211V13.5882H4.40047V11.3088H2.84954Z" fill="#038733" />
                  <path d="M3.28517 0.660156V1.65739H2.31364V2.28451H3.28517V3.28174H3.9637V2.28451H4.93523V1.65739H3.9637V0.660156H3.28517Z" fill="#038733" />
                  <path d="M11.5164 2.61937V5.32614H8.87938V7.02833H11.5164V9.7351H13.3581V7.02833H15.9951V5.32614H13.3581V2.61937H11.5164Z" fill="#038733" />
                </svg>
                <svg class="absolute left-1 top-0 h-12 w-6" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3235 17.5098V19.2193H11.658V20.2944H13.3235V22.0039H14.4867V20.2944H16.1522V19.2193H14.4867V17.5098H13.3235Z" fill="#038733" />
                  <path d="M2.84954 11.3088V13.5882H0.628906V15.0216H2.84954V17.301H4.40047V15.0216H6.6211V13.5882H4.40047V11.3088H2.84954Z" fill="#038733" />
                  <path d="M3.28517 0.660156V1.65739H2.31364V2.28451H3.28517V3.28174H3.9637V2.28451H4.93523V1.65739H3.9637V0.660156H3.28517Z" fill="#038733" />
                  <path d="M11.5164 2.61937V5.32614H8.87938V7.02833H11.5164V9.7351H13.3581V7.02833H15.9951V5.32614H13.3581V2.61937H11.5164Z" fill="#038733" />
                </svg>
              </div>
              <div v-if="10 <= rate && settled && result === 1">
                <svg class="absolute top-1/2 left-0 animate-[awesome-bet-rate_3.5s_ease-in_infinite]"
                     style="animation-delay: -0.5s" viewBox="0 0 11 11" width="8" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
                <svg class="absolute top-1/2 left-2 animate-[awesome-bet-rate_1.5s_ease-in_infinite]"
                     style="animation-delay: -0.2s" viewBox="0 0 11 11" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
                <svg class="absolute top-1/2 left-6 animate-[awesome-bet-rate_2.8s_ease-in_infinite]"
                     style="animation-delay: -0.5s" viewBox="0 0 11 11" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
                <svg class="absolute top-1/2 right-0 animate-[awesome-bet-rate_4s_ease-in_infinite]"
                     style="animation-delay: -2.5s" viewBox="0 0 11 11" width="8" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
                <svg class="absolute top-1/2 right-2 animate-[awesome-bet-rate_2.2s_ease-in_infinite]"
                     style="animation-delay: -0.1s" viewBox="0 0 11 11" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
                <svg class="absolute top-1/2 right-6 animate-[awesome-bet-rate_1.7s_ease-in_infinite]"
                     style="animation-delay: -0.7s" viewBox="0 0 11 11" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                </svg>
              </div>
            </div>
            <svg v-if="typeScrollableLeft"
                 class="absolute top-1/2 -translate-y-1/2 left-[5px]"
                 @click="scrollElementToLeft('type' + data.comment_id)"
                 width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.15625 7.75125L2.91208 4.5L6.15625 1.24875L5.1575 0.25L0.9075 4.5L5.1575 8.75L6.15625 7.75125Z" fill="white" />
            </svg>
            <svg v-if="typeScrollableRight"
                 class="absolute top-1/2 -translate-y-1/2 right-[5px]"
                 @click="scrollElementToRight('type' + data.comment_id)"
                 width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.726563 7.75125L3.7799 4.5L0.726563 1.24875L1.66656 0.25L5.66656 4.5L1.66656 8.75L0.726563 7.75125Z" fill="white" />
            </svg>
            <div v-if="typeScrollableLeft"
                 class="absolute top-1/2 -translate-y-1/2 left-[15px] w-[10px] h-[14px] bg-gradient-to-r from-zt-light to-transparent"></div>
            <div v-if="typeScrollableRight"
                 class="absolute top-1/2 -translate-y-1/2 right-[15px] w-[10px] h-[14px] bg-gradient-to-l from-zt-light to-transparent"></div>
          </div>
        </div>

        <div v-if="toEdit" class="flex flex-col gap-4 px-2.5 xl:px-4">
          <div class="flex flex-col gap-1 text-left">
            <label>Treść bonusu</label>
            <TinyMCE :id="'bonus-content-' + data.comment_id"
                    v-model="bonusContent"
                    :init="{
                      license_key: 'gpl',
                      height: 250,
                      menubar: false,
                      file_picker_types: 'image',
                      automatic_uploads: true,
                      images_upload_credentials: true,
                      image_title: true,
                      images_upload_handler: image_upload_handler,
                      block_unsupported_drop: false,
                      file_picker_callback: custom_callback,
                      content_css: false,
                      skin: false,
                      content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                      plugins: [
                        'autolink', 'lists', 'advlist', 'link', 'image', 'charmap', 'preview', 'anchor',
                        'visualblocks', 'code', 'fullscreen', 'media', 'table', 'code', 'wordcount'
                      ],
                      toolbar:
                        'undo redo | image link | formatselect | bold italic underline backcolor forecolor | \
                          fontsize | alignleft aligncenter alignright alignjustify | \
                          bullist numlist | code | removeformat '
                    }" />
          </div>
          <div class="flex flex-col gap-1 text-left">
            <label>Zasady bonusu</label>
            <TinyMCE :id="'bonus-details-' + data.comment_id"
                    v-model="bonusRules"
                    :init="{
                      license_key: 'gpl',
                      height: 250,
                      menubar: false,
                      content_css: false,
                      skin: false,
                      content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                      plugins: [
                        'autolink', 'lists', 'advlist', 'link', 'image', 'charmap', 'preview', 'anchor',
                        'visualblocks', 'code', 'fullscreen', 'media', 'table', 'code', 'wordcount'
                      ],
                      toolbar:
                        'undo redo | image link | formatselect | bold italic underline backcolor forecolor | \
                          fontsize | alignleft aligncenter alignright alignjustify | \
                          bullist numlist | code | removeformat '
                    }" />
          </div>
          <div class="flex flex-col gap-1 text-left">
            <label>Link do wydarzenia (opcjonalnie)</label>
            <input type="text" :id="'bonus-link' + data.comment_id" placeholder="Link do meczu np. z Flashscore, Sofascore..."
                   class="px-3 py-1 rounded-zt text-black" v-model="bonusLink" />
          </div>
        </div>

        <div v-else ref="content"
             class="px-5 pt-4 pb-2 break-words font-light xl:px-5" :class="isSuperkursAd && 'pt-0'">
          <div :id="'bonus-content-' + data.comment_id"
               class="bonus-content searched-in text-left text-[20px] leading-[21px]"
               v-html="bonusContent"></div>
          <div v-if="bonusLink" :id="'bonus-link' + data.comment_id"
               class="w-full flex justify-center cursor-pointer pt-4" @click="changeUrl(bonusLink)">
            <button class="zt-button">Odbierz bonus</button>
          </div>
          <div v-if="bonusRules" class="accordion mt-3" :id="'bonus-details-' + data.comment_id">
            <div class="accordion-item">
              <span v-if="bookmaker" class="accordion-header mb-0">
                <button class="!bg-transparent mx-auto relative flex items-center border-0 rounded-none transition
                          focus:outline-none text-xs uppercase underline text-zt-more zt-hover" type="button"
                        data-bs-toggle="collapse" :data-bs-target="'#details-' + data.comment_id"
                        aria-expanded="false" :aria-controls="'details-' + data.comment_id">
                  Szczegóły bonusu
                  <svg class="ml-1" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.25949 0.572876L4.51074 3.81704L7.76199 0.572876L8.76074 1.57163L4.51074 5.82163L0.260742 1.57163L1.25949 0.572876Z" fill="#93A3BA" />
                  </svg>
                </button>
              </span>
              <div :id="'details-' + data.comment_id" ref="rules"
                   class="accordion-collapse collapse" :class="{ show: !bookmaker, 'pt-3': bookmaker }"
                   :data-bs-parent="'#bonus-details-' + data.comment_id">
                <div class="bg-zt-light/35 relative rounded-xl border border-zt-light
                       py-3 pr-[15px] pl-[13px] text-[12px] leading-[21px]">
                  <div class="bonus-rules text-left list-disc" v-html="displayedBonusRules"
                       @click="$event.target.closest('.rules-expand') && (rulesExpanded = true)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="toEdit" class="flex justify-end text-xs px-2 py-4 xl:px-6 xl:text-sm">
          <button class="bg-zt-red px-2 py-1 rounded mx-2 zt-hover" @click="cancelEdit">Anuluj</button>
          <button class="bg-green-700 px-2 py-1 rounded zt-hover" @click="saveEdit()">Zatwierdź</button>
        </div>

        <hr v-if="!isModal" class="border-b border-zt-light/35 mx-auto w-full !border-t-0 mt-2 xl:mt-1" />

        <div v-if="!isModal" class="h-[42px] flex justify-between items-center pl-1.5 pr-3 xl:pl-2.5 xl:pr-4">
          <div class="group flex highlight-none grow">
            <div class="flex items-center gap-0.5 mr-1 text-sm duration-500 transition-colors cursor-pointer zt-hover"
                 :class="isLikedByMe ? 'text-[#419AD4]' : 'text-zt-more'" @click="toggleLike">
              <svg class="w-7 h-7 overflow-hidden rounded-full transition-colors duration-[1s] shrink-0"
                   :class="[{ 'animate-[like-animation_1s]': animate }, isLikedByMe ? 'stroke-transparent fill-[#419AD4]' : 'stroke-zt-more fill-transparent']"
                   viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.02052 3.29201C7.97899 3.31156 7.953 3.35321 7.95412 3.39843C7.97027 4.05479 7.97835 4.43525 7.97835 4.53979V4.83551L7.92797 4.93901C7.8714 5.05524 7.84218 5.10345 7.42778 5.76467C7.26549 6.02362 7.051 6.37847 6.95113 6.55326C6.8321 6.76157 6.7698 6.99652 6.77024 7.23539L6.77615 10.4265C6.77687 10.8176 7.09988 11.1342 7.49809 11.1342H11.0513L11.1808 11.0718C11.4717 10.9316 11.6853 10.6054 11.6868 10.2988C11.6874 10.1806 11.6836 10.1653 11.6225 10.0417C11.5868 9.96934 11.5594 9.90908 11.5617 9.90775C11.564 9.90642 11.631 9.87712 11.7107 9.84266C12.053 9.69455 12.2544 9.45916 12.269 9.19021C12.2767 9.04821 12.2428 8.95009 12.1285 8.78295C12.0824 8.71557 12.0447 8.65649 12.0447 8.65164C12.0447 8.6468 12.0558 8.64284 12.0695 8.64284C12.0831 8.64284 12.1498 8.61458 12.2177 8.58004C12.5277 8.4223 12.7052 8.12287 12.6549 7.84249C12.6214 7.65568 12.5212 7.50716 12.2986 7.31427L12.2256 7.25107L12.3095 7.16301C12.4176 7.04942 12.4832 6.95595 12.5262 6.85412C12.5546 6.78718 12.5609 6.74432 12.5612 6.6166C12.5617 6.37306 12.5044 6.20983 12.3687 6.06876C12.2778 5.97426 12.1765 5.91277 12.0332 5.86522L11.9155 5.82615C10.2991 5.81738 9.49093 5.81105 9.49096 5.80717C9.49102 5.80134 9.50466 5.6868 9.52127 5.55262C9.55932 5.24537 9.56347 4.6846 9.52919 4.48065C9.43159 3.89988 9.1171 3.44498 8.70331 3.28599C8.5997 3.24619 8.56565 3.2406 8.40398 3.23694C8.30366 3.23467 8.19168 3.2389 8.15517 3.24635C8.11864 3.25379 8.05805 3.27434 8.02052 3.29201ZM4.65918 6.73157H6.03585C6.1572 6.73157 6.25557 6.82819 6.25557 6.94737V11.2209C6.25557 11.3401 6.1572 11.4367 6.03585 11.4367H4.65918C4.53783 11.4367 4.43945 11.3401 4.43945 11.2209V6.94737C4.43945 6.82819 4.53783 6.73157 4.65918 6.73157Z" stroke-width="0.5" />
              </svg>
              <span class="text-xs xl:text-sm">Lubię to!</span>
              <span @animationend="wsLikeAdded = false" class="text-xs mt-[1px] xl:ml-[3px] xl:mr-1">({{ likeCount }})</span>
            </div>
          </div>
          <div @click="toggleAnswer" class="flex flex-nowrap justify-center items-center cursor-pointer highlight-none zt-hover">
            <button data-bs-toggle="collapse" :data-bs-target="'#Comment-input-' + data.comment_id"
                    class="text-zt-more text-xs xl:text-sm">Komentarze ({{ commentWithAnswersCount }})</button>
          </div>
        </div>
        <div :id="'Comment-input-' + data.comment_id" class="collapse">
          <div class="w-full h-0.5 bg-zt-light"></div>
          <div v-if="isLoggedIn() && !isUserBlocking" class="flex relative py-2 justify-center items-center gap-x-2 px-1.5 xl:px-2.5">
            <img class="rounded-full w-[30px] h-[30px] min-w-[30px]" height="30" width="30" :src="WP.user.avatar" alt="" @error="handleUserAvatarError($event)"/>
            <textarea placeholder="Napisz komentarz..." ref="textarea" rows="1" @focus="resize()" @keyup="resize()"
                      v-model="answerContent"
                      class="font-light py-2 pl-3 !text-text textarea-comments self-stretch overflow-hidden resize-none
                             focus:outline-none pr-10"></textarea>
            <div class="absolute top-0 h-full flex items-center right-[18px] xl:right-2">
              <button class="zt-hover xl:h-[calc(100%-20px)] xl:px-4" aria-label="Dodaj komentarz" @click="addComment">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="isUserBlocking" class="flex justify-center items-center p-2 mt-0.5">
            <span class="text-zt-red text-[12px] zt-hover cursor-pointer truncate" @click="openLoginModal">
              Zostałeś zablokowany przez tego Typera, nie mozesz skomentować jego typu
            </span>
          </div>
          <div v-else class="flex justify-center items-center p-2 text-sm">
            <div class="flex justify-center items-center gap-1 zt-hover cursor-pointer" @click="openLoginModal">
              <span class="text-zt-red font-medium">Zaloguj się,</span>
              <span>aby dodać komentarz</span>
            </div>
          </div>
        </div>
      </div>

      <TransitionGroup name="fade">
        <comment v-for="comment in commentsToShow"
                 :key="comment.comment_id"
                 :data="comment"
                 :isBlocked="betAuthorBlocked(comment.author_id)"
                 :isBlocking="betAuthorBlocking(comment.author_id)"
                 :isBetComment="true"
                 :blockedUserIds="blockedUserIds"
                 @blockUser="commentAuthorId => $emit('blockUser', commentAuthorId)"
                 @unblockUser="commentAuthorId => $emit('unblockUser', commentAuthorId)" />
      </TransitionGroup>

      <div v-if="!showAllComments && comments.length > 1" class="flex justify-center items-center">
        <button class="bg-zt-main shadow-around px-6 py-2 text-[12px] underline rounded-md mt-2"
                @click="showAllComments = true">
          Pokaż {{ comments.length - 1 }} {{ inflectNumber(comments.length - 1, ['komentarz', 'komentarze', 'komentarzy']) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '../Comment.vue';
import { defineAsyncComponent } from 'vue';
import utils_mixin from '../../mixins/utils_mixin';
import { useUserStore } from '../../stores/UserStore';
import { Notice } from '../../../assets/js/Notice';
import TinyMCE from '../TinyMCE.vue';

export default {
  name: 'BetAd',
  emits: ['blockUser', 'unblockUser', 'edit', 'changeBetDay', 'settleBet', 'editBetIncrement'],
  props: {
    data: Object,
    isBlocked: Boolean,
    isBlocking: Boolean,
    isWarned: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
    warnedUserIds: Array,
    isFeaturedBet: Boolean,
    isModal: Boolean,
    betEdited: Number
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    TinyMCE,
    Comment,
    BetOptionsModal: defineAsyncComponent(() => import('../modals/BetOptionsModal.vue')),
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    this.bookmakersLinks = {
      fortuna: '/kod-promocyjny-fortuna/',
      lvbet: '/kod-promocyjny-lvbet/',
      ewinner: '/kody-promocyjne-ewinner/',
      betfan: '/kod-promocyjny-betfan/',
      betclic: '/kod-promocyjny-betclic/',
      totolotek: '/kod-promocyjny-totolotek/',
      forbet: '/kod-promocyjny-forbet/',
      pzbuk: '/kod-bonusowy-pzbuk/',
      sts: '/sts-kod-promocyjny/',
      superbet: '/kod-promocyjny-superbet/',
      totalbet: '/kod-promocyjny-totalbet/',
      fuksiarz: '/fuksiarz-kod-promocyjny/',
      etoto: '/kod-bonusowy-etoto/',
      betx: '/kod-promocyjny-betx/',
      bestbet: '/bestbet-bonus/',
      betcris: '/kod-promocyjny-betcris/',
      traf: '/kod-promocyjny-traf/',
      okbet: '/kod-promocyjny-okbet/',
      noblebet: '/kod-promocyjny-noblebet/',
      goplusbet: '/gobet-kod-promocyjny/',
      betters: '/betters-kod-promocyjny/',
      bwin: '/bwin-kod-promocyjny/',
      comeon: '/comeon-kod-bonusowy/',
      admiralbet: '/admiralbet-kod-promocyjny/',
      wettarena: '/wett-arena-kod-promocyjny/',
      lebull: '/lebull-kod-promocyjny/',
      betsport: '/kod-promocyjny-betsport/',
    };
    this.disciplines = [
      { title: 'Piłka nożna', search: true, index: 0 },
      { title: 'Tenis', search: true, index: 1 },
      { title: 'Hokej', search: true, index: 2 },
      { title: 'Koszykówka', search: true, index: 3 },
      { title: 'Siatkówka', search: true, index: 4 },
      { title: 'Sporty walki', search: true, index: 5 },
      { title: 'Sporty zimowe', search: true, index: 6 },
      { title: 'Baseball', search: true, index: 9 },
      { title: 'E-sport', search: true, index: 11 },
      { title: 'Formuła 1', search: true, index: 24 },
      { title: 'Piłka ręczna', search: true, index: 19 },
      { title: 'Dart', search: true, index: 10 },
      { title: 'Futbol Am.', search: true, index: 12 },
      { title: 'Rugby', search: true, index: 21 },
      { title: 'Żużel', search: true, index: -1 },
      { title: 'Lekkoatletyka', search: true, index: -1 },
      { title: 'Wyścigi hartów', search: true, index: -1 },
      { title: 'Wyścigi konne', search: true, index: -1 },
      { title: 'Inna', search: true, index: null }
    ];
    return {
      editIsBetBuilder: false,
      typeScrollableLeft: false,
      typeScrollableRight: false,
      matchScrollableLeft: false,
      matchScrollableRight: false,
      isBetOptionsModalOpen: false,
      comments: [],
      animate: false,
      followChanged: false,
      showNewBetShadow: false,
      answerContent: '',
      lastCommentTimestamp: 0,
      settled: Number(this.data.settled),
      result: Number(this.data.result),
      isAnswerOpen: false,
      wsLikeAdded: false,
      showAllComments: false,
      userCanEdit: false,
      toEdit: false,
      editDate: '',
      promoUrl: '',
      isUserWithAdminPanel: this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor',
      likeCount: this.data.like_count,
      rulesExpanded: false,
      rulesPreviewCount: 4,
    };
  },
  computed: {
    isBetbuilder() {
      return this.betEdited && this.data.is_betbuilder === '1';
    },
    id() {
      return Number(this.data.comment_id);
    },
    postId() {
      return Number(this.data.post_id);
    },
    authorId() {
      return Number(this.data.author_id);
    },
    authorAvatar() {
      return this.data.author_avatar;
    },
    authorName() {
      return this.data.author_name.replace(/ /, '\n');
    },
    bonusLink() {
      return this.betEdited && this.data.content.split('link::')[1];
    },
    bonusRules() {
      return this.betEdited && this.data.content.split('rules::')[1].split('link::')[0];
    },
    bonusRulesItemsCount() {
      return this.bonusRules ? this.parseBonusRules(this.bonusRules).ends.length : 0;
    },
    displayedBonusRules() {
      if (this.rulesExpanded || this.bonusRulesItemsCount <= this.rulesPreviewCount) {
        return this.bonusRules;
      }
      const { root, ends } = this.parseBonusRules(this.bonusRules);
      const rest = ends[this.rulesPreviewCount - 1];
      const cut = rest.cloneRange();
      const lastNode = cut.startContainer.childNodes[cut.startOffset - 1];
      rest.setEnd(root, root.childNodes.length);
      rest.deleteContents();
      const expand = root.ownerDocument.createElement('button');
      expand.type = 'button';
      expand.className = 'rules-expand ml-1 text-xs font-normal uppercase underline text-zt-more zt-hover';
      expand.textContent = 'Rozwiń';
      if (/^(LI|P|DIV|H[1-6])$/.test(lastNode?.nodeName)) {
        lastNode.append(expand);
      } else {
        cut.insertNode(expand);
      }
      return root.innerHTML;
    },
    bonusContent() {
      return this.betEdited && this.data.content.split('rules::')[0];
    },
    bookmaker() {
      return this.betEdited && this.data.bookmaker;
    },
    bookmakerLogoName() {
      return this.data.bookmaker.replace(/<span>|<\x2fspan>/gi, '');
    },
    disciplineLogoName() {
      return this.data.discipline.replace(/<span>|<\x2fspan>/gi, '');
    },
    rate() {
      return this.data.rate;
    },
    discipline() {
      return this.betEdited && this.data.discipline;
    },
    hour() {
      return this.betEdited && this.data.hour;
    },
    matchName() {
      return this.betEdited && this.data.match_name;
    },
    type() {
      return this.betEdited && this.data.type;
    },
    isFollowed() {
      return this.userStore.isUserFollowed(this.authorId);
    },
    isUserBlocked() {
      return this.isBlocked;
    },
    isUserBlocking() {
      return this.isBlocking;
    },
    likes() {
      if (this.isModal) {
        return null;
      }
      return this.data.likes;
    },
    isLikedByMe() {
      if (this.isModal || this.likeCount === 0) {
        return false;
      }
      return this.userStore.isCommentLiked(this.id);
    },
    commentWithAnswersCount() {
      let count = 0;
      if (this.comments.length > 0) {
        this.comments.forEach(child => {
          if ('answers' in child && child.answers.length > 0) {
            count += child.answers.length;
          }
          count++;
        });
      }
      return count;
    },
    commentsToShow() {
      let commentsSorted = this.comments.slice().sort((a, b) => {
        if (a.pinned_to_all !== b.pinned_to_all) {
          return b.pinned_to_all - a.pinned_to_all;
        }

        return new Date(b.date) - new Date(a.date);
      });

      if (this.showAllComments) {
        return commentsSorted;
      } else {
        return commentsSorted.slice(0, 1);
      }
    },
    isSuperkursAd() {
      if (this.bookmaker) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isFollowed() {
      this.followChanged = true;
      setTimeout(this.refreshTooltips, 500);
    }
  },
  mounted() {
    this.comments = this.data.answers ? this.data.answers : [];
    this.userCanEdit = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
    this.checkAndRedirectToComment();
    this.addAdditionalStyles();
    this.ifHasJustBeenAdded();
    this.showBetRedirectBg();
    if (this.data.bookmaker) {
      this.promoUrl = utils_mixin.methods.getBookiePromoLink(this.data.bookmaker);
    }
    this.editIsBetBuilder = this.data.is_betbuilder === '1';
    setTimeout(this.refreshTooltips, 500);

    socket?.on('like-added', data => {
      if (data.postId === Number(this.WP.id)) {
        this.addLikeBySomeoneElse(data);
      }
    });
    socket?.on('like-removed', data => {
      if (data.postId === Number(this.WP.id)) {
        this.removeLikeBySomeoneElse(data);
      }
    });
  },
  methods: {
    parseBonusRules(html) {
      const root = new DOMParser().parseFromString(html, 'text/html').body;
      const doc = root.ownerDocument;
      const ends = [];
      let prev = doc.createRange();
      prev.setStart(root, 0);
      const pointAt = (node, after) => {
        const point = doc.createRange();
        after ? point.setStartAfter(node) : point.setStartBefore(node);
        return point;
      };
      const pushEnd = point => {
        const segment = doc.createRange();
        segment.setStart(prev.startContainer, prev.startOffset);
        segment.setEnd(point.startContainer, point.startOffset);
        if (segment.toString().trim() || segment.cloneContents().querySelector('img')) ends.push(point);
        prev = point;
      };
      for (const child of [...root.childNodes]) {
        if (child.nodeName === 'UL' || child.nodeName === 'OL') {
          [...child.children].forEach(li => pushEnd(pointAt(li, true)));
          continue;
        }
        if (child.nodeType === Node.ELEMENT_NODE) {
          child.querySelectorAll('br').forEach(br => pushEnd(pointAt(br, false)));
        }
        pushEnd(pointAt(child, true));
      }
      return { root, ends };
    },
    checkRefChildrenStyles(refName) {
      const contentElement = this.$refs[refName];
      if (contentElement) {
        const spanElements = contentElement.querySelectorAll('span[style]');

        if (spanElements.length > 0) {
          contentElement.classList.remove('content-leading');
        } else {
          contentElement.classList.add('content-leading');
        }
      }
    },
    getBookmakerLink(bookmakerName) {
      const regex = /<span>|<\x2fspan>/gi;
      return this.bookmakersLinks[bookmakerName.toLowerCase().replaceAll(regex, '')] ?? '#';
    },
    handleClick() {
      if (this.bookmaker) {
        this.changeUrl(this.getBookmakerLink(this.bookmaker));
      } else {
        window.location.href = '/typer/' + this.authorId;
      }
    },
    changeUrl(link, isFeaturedBet) {
      if (link) {
        if (isFeaturedBet) {
          window.open(link, '_self');
        } else {
          window.open(link, '_blank');
        }
      }
    },
    scrollTypeHandler(e) {
      this.typeScrollableLeft = e.target.scrollLeft > 0;
      this.typeScrollableRight = e.target.scrollLeft < e.target.scrollWidth - e.target.offsetWidth;
    },
    scrollMatchHandler(e) {
      this.matchScrollableLeft = e.target.scrollLeft > 0;
      this.matchScrollableRight = e.target.scrollLeft < e.target.scrollWidth - e.target.offsetWidth;
    },
    scrollElementToLeft(elementId) {
      let element = document.getElementById(elementId);
      if (element) {
        element.scroll(0, 0);
      }
    },
    scrollElementToRight(elementId) {
      let element = document.getElementById(elementId);
      if (element) {
        element.scroll(element.scrollWidth, 0);
      }
    },
    showBetOptionsModal(elementIdPrefix) {
      if (window.size.desktop && !this.isBlocked) {
        this.smoothScrollToElement(elementIdPrefix);
      }
      this.isBetOptionsModalOpen = true;
      this.blockScrolling();
    },
    hideBetOptionsModal() {
      this.isBetOptionsModalOpen = false;
      this.unblockScrolling();
    },
    follow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      if (this.blockedUserIds.includes(this.authorId)) {
        return;
      }
      this.userStore.followUser(this.authorId, isCancel);
    },
    unfollow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      this.userStore.unfollowUser(this.authorId, isCancel);
    },
    blockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_block_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.isBetOptionsModalOpen = false;
            this.$emit('blockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.unblockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    unblockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_unblock_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('unblockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.blockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    toggleLike() {
      this.animate = true;
      if (this.isLikedByMe) {
        this.animate = false;
        return this.removeLike();
      } else {
        return this.addLike();
      }
    },
    addLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_add_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.addLikedCommentId(this.id);
              this.likeCount++;
              socket?.emit('like-added', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: response.data.data.comment_like.user_id,
              });
            }
          }
        });
    },
    removeLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_delete_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.removeLikedCommentId(this.id);
              this.likeCount--;
              socket?.emit('like-removed', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: this.WP.user.id,
                ip: this.userIP
              });
            }
          }
        });
    },
    addLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount++;
        this.wsLikeAdded = true;
      }
    },
    removeLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount--;
      }
    },
    ifHasJustBeenAdded() {
      if (this.data.showNewBetShadow) {
        this.observeBetShadow();
      }
    },
    checkAndRedirectToComment() {
      const redirectURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      const isRedirecting = redirectURL.includes('#comment-');
      const dashIndex = redirectURL.lastIndexOf('-');

      if (isRedirecting && dashIndex && redirectURL !== expectedURL) { // only for hidden bet comments
        const commentId = redirectURL.substring(dashIndex + 1);
        this.comments.forEach((comment) => {
          if (comment.comment_id === commentId && this.comments.length > 1) {
            this.showAllComments = true;
          } else if (comment.answers.length > 0) {
            comment.answers.forEach((comment2ndLvl) => {
              if (comment2ndLvl.comment_id === commentId) {
                this.showAllComments = true;
              }
            })
          }
        })
      }
    },
    showBetRedirectBg() {
      const currentURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      if (currentURL === expectedURL) {
        this.observeBetShadow();
      }
    },
    observeBetShadow() {
      this.showNewBetShadow = true;
      let threshold = this.$el.getBoundingClientRect().height > window.innerHeight - 100
        ? (window.innerHeight - 100) / this.$el.getBoundingClientRect().height
        : 1.0;
      const newBetObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => (this.showNewBetShadow = false), 3000);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: threshold,
          rootMargin: '0px 0px 0px 0px'
        }
      );
      setTimeout(() => newBetObserver.observe(this.$el), 400);
    },
    checkInputForEmojiCode() {
      this.answerContent = this.answerContent.replace("+++", "✅");
      this.answerContent = this.answerContent.replace("---", "✖");
    },
    resize() {
      const { textarea } = this.$refs;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      this.checkInputForEmojiCode();
    },
    toggleAnswer() {
      this.isAnswerOpen = !this.isAnswerOpen;

      if (this.isAnswerOpen) {
        setTimeout(() => {
          const { textarea } = this.$refs;
          if (textarea) {
            textarea.focus();
          }
        }, 200);
      }
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }

      let commentContent = this.answerContent.replaceAll("✅", "<span style='font-size: 18px;'>✅</span>");
      commentContent = commentContent.replaceAll("✖", "<span style='font-size: 18px;'>✖</span>");

      if (commentContent.replace(/\s/g, "").length < 1) {
        this.addInternalNotification(new Notice().setContent('Dodaj treść komentarza'));
        return;
      }

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          post_id: this.postId,
          parent_id: this.id,
          parent_type: {
            parent: 'BetAd',
            grandparent: 'TD'
          },
          content: commentContent.trim(),
          comment_type: 'comment',
          year: this.DateTime.fromSQL(this.WP.dailyBetsDate).year,
          month: this.DateTime.fromSQL(this.WP.dailyBetsDate).month,
        })
        .then(response => {
          if (response.data.success) {
            this.comments.unshift(response.data.data.comment);
            this.isAnswerOpen = false;
            this.answerContent = '';
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    betAuthorBlocked(authorId) {
      return this.blockedUserIds.includes(Number(authorId));
    },
    betAuthorBlocking(authorId) {
      return this.blockingUserIds.includes(Number(authorId));
    },
    edit() {
      this.toEdit = true;
    },
    saveEdit() {
      let content = tinymce.get('bonus-content-' + this.data.comment_id).getContent() +
        'rules::' + tinymce.get('bonus-details-' + this.data.comment_id).getContent() +
        'link::' + document.getElementById('bonus-link' + this.data.comment_id).value;

      content = content.replace(/[\n\r]+/g, ""); // Usuwa nowe linie
      content = content.replace(/ +(?= )/g, ""); // Usuwa podwójne spacje

      this.isSuperkursAd ? this.saveEditSuperkurs(content) :this.saveEditOther(content);
    },
    saveEditSuperkurs(content) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_update_bet',
          post_id: this.WP.id,
          discipline: document.getElementById('discipline' + this.data.comment_id).value,
          hour: document.getElementById('hour' + this.data.comment_id).textContent,
          bookmaker: document.getElementById('bookmaker' + this.data.comment_id).value,
          date: this.editDate,
          match_name: document.getElementById('match-name' + this.data.comment_id).textContent,
          type: document.getElementById('type' + this.data.comment_id).textContent,
          rate: document.getElementById('rate' + this.data.comment_id).textContent,
          analysis: content,
          is_betbuilder: this.editIsBetBuilder,
          id: this.data.comment_id
        })
        .then(response => {
          if (response.data.success) {
            this.data.discipline = document.getElementById('discipline' + this.data.comment_id).value;
            this.data.hour = document.getElementById('hour' + this.data.comment_id).textContent;
            this.data.bookmaker = document.getElementById('bookmaker' + this.data.comment_id).value;
            this.data.match_name = document.getElementById('match-name' + this.data.comment_id).textContent;
            this.data.type = document.getElementById('type' + this.data.comment_id).textContent;
            this.data.rate = document.getElementById('rate' + this.data.comment_id).textContent;
            this.data.content = content;
            this.data.is_betbuilder = this.editIsBetBuilder ? '1' : '0';
            this.checkRefChildrenStyles('content');
            this.checkRefChildrenStyles('rules');
            this.$emit('editBetIncrement');
            this.toEdit = false;
            if (this.editDate !== '') {
              let choosenDate = this.DateTime.fromSQL(this.editDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
              let postDate = this.DateTime.fromSQL(this.WP.dailyBetsDate);
              let days = this.Interval.fromDateTimes(postDate, choosenDate).length('days');
              if (days !== 0) {
                this.$emit('changeBetDay', this.id);
              }
            }
          }
        });
    },
    saveEditOther(content) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_update_bet_discussion_or_ad',
          content: content,
          id: this.data.comment_id
        })
        .then(response => {
          if (response.data.success) {
            this.data.content = content;
            this.toEdit = false;
            this.checkRefChildrenStyles('content');
            this.checkRefChildrenStyles('rules');
            this.$emit('editBetIncrement');
          }
        });
    },
    async image_upload_handler(blobInfo, progress) {
      const formData = new FormData();

      formData.append('endpoint', 'api_upload_image');
      formData.append('file', blobInfo.blob(), blobInfo.filename());

      const response = await axios.post(this.WP.slowAjaxUrl, formData, {
        onUploadProgress: (event) => {
          if (event.total) {
            progress(Math.round(event.loaded * 100 / event.total));
          }
        }
      });

      if (!response.data?.success || typeof response.data?.data !== 'string') {
        throw new Error('Nieprawidłowa odpowiedź serwera');
      }

      return response.data.data;
    },
    custom_callback(cb, value, meta) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.addEventListener('change', (e) => {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.addEventListener('load', () => {
          const id = 'blobid' + (new Date()).getTime();
          const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        });
        reader.readAsDataURL(file);
      });
      input.click();
    },
    cancelEdit() {
      this.toEdit = false;
    },
    deleteBet() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_delete_comment',
          id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.addInternalNotification(new Notice().setContent(response.data.data.message + '. Odśwież stronę'));
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    settleBet(result) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_settle_bet',
          bet_id: this.id,
          result: Number(result),
          author_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.settled = Number(response.data.data.bet.settled);
            this.result = Number(response.data.data.bet.result);
          }
        });
    },
    getSettleBgColor() {
      return {
        'rate-won': this.settled && this.result === 1,
        'rate-lost': this.settled && this.result === -1,
        'rate-return': this.settled && this.result === 0,
        'invalid-bet': this.settled && this.result === -2
      };
    },
    addAdditionalStyles() {
      let divElement = document.querySelector("#bonus-content-" + this.data.comment_id);

      if (divElement) {
        let imgElement = divElement.querySelector("img");

        if (imgElement) {
          imgElement.style.borderRadius = "5px";
          imgElement.style.marginTop = "15px";
          imgElement.style.marginBottom = "5px";
        }
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    }
  },
};
</script>

<style scoped>
.searched-in .searched-element {
  background-color: #6FAD6E99;
}
.bonus-content img {
  border-radius: 5px;
  margin: 10px auto;
}

.bonus-content > :deep(ul),
.bonus-rules > :deep(ul) {
  list-style-type: disc;
  padding-left: 20px;
}

.bonus-content > :deep(ol),
.bonus-rules > :deep(ol) {
  list-style-type: decimal;
  padding-left: 15px;
}
</style>